import { gql } from "lib/apolloClient";
import { gradesItemFragment } from "./ScoreCategoriesFragments";

export const createPointAssessmentSetMutation = gql`
  mutation createPointAssessmentSet($input: [CreatePointAssessmentSetInput!]) {
    planner {
      createPointAssessmentSet(input: $input) {
        warning
        response {
          id
          label
          type
          isShowGradeBoundaries
          associatedEntities {
            id
            ... on Course {
              id
              title
            }
            ... on Subject {
              id
              name
            }
            ... on Grade {
              ...gradeItem
            }
          }
          categories {
            id
            label
            colorCode
            percentageWeight
            hlWeight
            slWeight
            values {
              id
              value
              minValue
              maxValue
              genericTag {
                id
                label
              }
              valueType
              weightageType
            }
            gradeBoundary {
              id
            }
            gradeScaleType
            displaySequence
          }
        }
      }
    }
  }
  ${gradesItemFragment.gradeFragment}
`;

export const updatePointAssessmentSetMutation = gql`
  mutation updatePointassessmentSet($input: [UpdatePointAssessmentSetInput!]) {
    planner {
      updatePointAssessmentSet(input: $input) {
        warning
        response {
          id
          label
          type
          isShowGradeBoundaries
          associatedEntities {
            id
            ... on Course {
              id
              title
            }
            ... on Subject {
              id
              name
            }
            ... on Grade {
              ...gradeItem
            }
          }
          categories {
            id
            label
            colorCode
            percentageWeight
            hlWeight
            slWeight
            values {
              id
              value
              minValue
              maxValue
              genericTag {
                id
                label
              }
              valueType
              weightageType
            }
            gradeBoundary {
              id
            }
            gradeScaleType
            displaySequence
          }
        }
      }
    }
  }
  ${gradesItemFragment.gradeFragment}
`;

export const deletePointAssessmentSetMutation = gql`
  mutation deletePointAssessmentSet($input: DeletePointAssessmentSetInput!) {
    planner {
      deletePointAssessmentSet(input: $input)
    }
  }
`;

export const copyPointAssessmentMutation = gql`
  mutation copyPointAssesment($input: CopyPointAssessmentSetInput!) {
    planner {
      copyPointAssessmentSet(input: $input) {
        isSuccess
        warning
        academicCriteriaSet {
          id
          label
        }
      }
    }
  }
`;

export const bulkCopyPointAssessmentSetMutation = gql`
  mutation bulkCopyPointAssessmentSet(
    $input: BulkCopyPointAssessmentSetInput!
  ) {
    planner {
      bulkCopyPointAssessmentSet(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
